import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BookOpen, Trophy, Layout, ShieldCheck, Rocket, Gift, Printer, Home } from 'lucide-react';
import './LandingPage.css';
import Footer from '../components/Footer';
import HeaderRouter from '../components/HeaderRouter';
import { trackEvent, EVENT_CLICK, EVENT_VALUE_REGISTER, EVENT_VALUE_EXPLORE_CURRICULUM } from '../utils/analytics';
import KippyMascot from '../components/KippyMascot';
import HowItWorks from '../components/landing/HowItWorks';

const LandingPage = () => {
  const navigate = useNavigate();

  const navigateToRegisterPage = () => {
    trackEvent(EVENT_CLICK, {
      name: EVENT_VALUE_REGISTER
    });
    navigate('/register');
  };

  const navigateToCurriculumPage = () => {
    trackEvent(EVENT_CLICK, {
      name: EVENT_VALUE_EXPLORE_CURRICULUM
    });
    navigate('/curriculum');
  };

  return (
    <div className="landing-wrapper">
      {/* TOP NAVIGATION */}
      <HeaderRouter />
      <div className="desktop-only">
        <KippyMascot size="smaller" showBubble={true} fixed={true} message="Hello, I am Kippy!" />
      </div>

      {/* HERO SECTION */}
      <header className="hero">
        <div className="bg-shape shape-1"></div>
        <div className="bg-shape shape-2"></div>
        <div className="bg-shape shape-3"></div>

        <div className="hero-content">
          <h1>Master Every Subject Through <span className="pop-text">Play!</span></h1>
          <p>The ultimate quiz platform designed to help students excel in school while having the time of their lives.</p>

          <div className="hero-btns">
            <button className="btn-primary-lg" onClick={navigateToRegisterPage}>Start Learning Free</button>
            <button className="btn-secondary-lg" onClick={navigateToCurriculumPage}>Explore</button>
            <button className="btn-3d-pop" onClick={() => navigate('/try-demo')}>
              <Rocket size={22} fill="white" />
              Try A Quiz
            </button>
          </div>
        </div>

        {/* HERO IMAGE PREVIEW */}
        <div className="hero-image">
          <div className="hero-card-preview">
            <div className="mock-quiz-card">
              <div className="mock-line"></div>
              <div className="mock-options">
                <span></span><span></span><span></span>
              </div>
            </div>
          </div>
        </div>
      </header>
      <HowItWorks onGetStarted={navigateToRegisterPage} />

      {/* FEATURES SECTION */}
      <section className="features">
        <div className="section-title">
          <h2>Why Choose Knolup?</h2>
          <p>Everything you need to boost academic performance in one place.</p>
        </div>

        <div className="feature-grid">
          <FeatureCard
            icon={<BookOpen size={32} color="#166534" />}
            title="Curriculum Based"
            desc="Questions organized by Grade, Subject, and Topic to match school standards."
          />
          <FeatureCard
            icon={<Trophy size={32} color="#b45309" />}
            title="Gamified Success"
            desc="Earn points, badges, and climb the leaderboard as you master new topics."
          />
          <FeatureCard
            icon={<Layout size={32} color="#075985" />}
            title="Interactive UI"
            desc="Designed specifically for young minds with colorful and intuitive interfaces."
          />
          <FeatureCard
            icon={<ShieldCheck size={32} color="#9d174d" />}
            title="Parental Insights"
            desc="Detailed reports for parents to track progress and identify areas for improvement."
          />
          <FeatureCard
            icon={<Gift size={32} color="#6d28d9" />}
            title="Real Rewards"
            desc="Collect points for every correct answer and redeem them for exciting goodies and avatars!"
          />
          <FeatureCard
            icon={<Printer size={32} color="#059669" />}
            title="Printable Fun"
            desc="Turn your online success into offline fun! Download custom worksheets and certificates based on your progress."
          />
        </div>
      </section>

      <Footer />
    </div>
  );
};

const FeatureCard = ({ icon, title, desc }) => (
  <div className="f-card">
    <div className="f-icon-wrapper">{icon}</div>
    <h3>{title}</h3>
    <p>{desc}</p>
  </div>
);

export default LandingPage;